import { GRID_SIZE } from './gridConstants';
export var COUNTER_TYPES = [
    { id: 'penny', labelKey: 'text.coinsAndCountersPenny', twoSided: true, defaultDimensions: { width: 70, height: 70 } },
    { id: 'nickel', labelKey: 'text.coinsAndCountersNickel', twoSided: true, defaultDimensions: { width: 70, height: 70 } },
    { id: 'dime', labelKey: 'text.coinsAndCountersDime', twoSided: true, defaultDimensions: { width: 60, height: 60 } },
    { id: 'quarter', labelKey: 'text.coinsAndCountersQuarter', twoSided: true, defaultDimensions: { width: 80, height: 80 } },
    { id: 'halfDollar', labelKey: 'text.coinsAndCountersHalfDollar', twoSided: true, defaultDimensions: { width: 90, height: 90 } },
    { id: 'bean', labelKey: 'text.coinsAndCountersBean', twoSided: true, defaultDimensions: { width: 130, height: 85 } },
    // Game marker, X, O — canvas: 2×2 stage grid box (XD spec).
    // Popup keeps original (pre-grid-alignment) preview size so the popup
    // layout doesn't change.
    { id: 'gameMarker', labelKey: 'text.coinsAndCountersGameMarker', twoSided: true, defaultDimensions: { width: GRID_SIZE * 2, height: GRID_SIZE * 2 }, previewDimensions: { width: 110, height: 110 } },
    { id: 'x', labelKey: 'text.coinsAndCountersX', twoSided: false, defaultDimensions: { width: GRID_SIZE * 2, height: GRID_SIZE * 2 }, previewDimensions: { width: 130, height: 130 } },
    { id: 'o', labelKey: 'text.coinsAndCountersO', twoSided: false, defaultDimensions: { width: GRID_SIZE * 2, height: GRID_SIZE * 2 }, previewDimensions: { width: 130, height: 130 } },
    // Stick + bundle-of-10 canvas: height = 1.5 grid cells, widths kept
    // proportional. Popup keeps original 18×110 / 75×110 preview sizes.
    { id: 'stick', labelKey: 'text.coinsAndCountersStick', twoSided: false, defaultDimensions: { width: GRID_SIZE * 1.5 * (18 / 110), height: GRID_SIZE * 1.5 }, previewDimensions: { width: 18, height: 110 } },
    { id: 'bundle10', labelKey: 'text.coinsAndCountersBundle10', twoSided: false, defaultDimensions: { width: GRID_SIZE * 1.5 * (75 / 110), height: GRID_SIZE * 1.5 }, previewDimensions: { width: 75, height: 110 } },
    // Bundle-of-100 canvas: 2×2 grid cells. Popup keeps the original 150×150.
    { id: 'bundle100', labelKey: 'text.coinsAndCountersBundle100', twoSided: false, defaultDimensions: { width: GRID_SIZE * 2, height: GRID_SIZE * 2 }, previewDimensions: { width: 150, height: 150 } },
];
export var COUNTER_TYPE_BY_ID = COUNTER_TYPES.reduce(function (acc, t) {
    acc[t.id] = t;
    return acc;
}, {});
export var MAX_COUNTERS_PER_CONFIG = 10;
// Groups peers for "instance number" purposes (announced in the aria-label):
// game markers and beans are counted per color, everything else per type.
// Keep this the single source of truth — both the widget (reading the
// number) and the toolbar (assigning `instanceOrdinal` on placement) key
// off of it, so the two stay in sync.
export var getCoinsAndCountersInstanceKey = function (counterType, color) {
    if (counterType === 'gameMarker')
        return "gameMarker_".concat(color !== null && color !== void 0 ? color : '');
    if (counterType === 'bean')
        return "bean_".concat(color !== null && color !== void 0 ? color : '');
    return counterType;
};
// 5-column × 3-row grid layout matches the Adobe XD design.
export var POPUP_GRID_COLUMNS = 5;
// Column layout (read top→bottom per column):
// Col 1: Penny, Nickel, Dime
// Col 2: Quarter, Half-dollar
// Col 3: Game marker, X, O
// Col 4: Stick, Bundles of 10, Bundles of 100
// Col 5: Bean
export var POPUP_ROW_LAYOUT = [
    ['penny', 'quarter', 'gameMarker', 'stick', 'bean'],
    ['nickel', 'halfDollar', 'x', 'bundle10', null],
    ['dime', null, 'o', 'bundle100', null],
];
// Game-marker palette — 10 colors from the XD design, left → right.
// Each entry has a variant id (used as the `color` field on instance data),
// a hex (only for the swatch button's visible fill in the picker), and an
// `asset` pointing to the pre-rendered marker SVG for that color.
export var GAME_MARKER_PALETTE = [
    { id: 'red', hex: '#e53935', asset: './assets/images/manipulative/coinsAndCounters/markerRed.svg', colorLabelKey: 'text.coinsAndCountersColor_red' },
    { id: 'yellow', hex: '#fbc02d', asset: './assets/images/manipulative/coinsAndCounters/markerYellow.svg', colorLabelKey: 'text.coinsAndCountersColor_yellow' },
    { id: 'blue', hex: '#1e88e5', asset: './assets/images/manipulative/coinsAndCounters/markerBlue.svg', colorLabelKey: 'text.coinsAndCountersColor_blue' },
    { id: 'brown', hex: '#8d4e25', asset: './assets/images/manipulative/coinsAndCounters/markerBrown.svg', colorLabelKey: 'text.coinsAndCountersColor_brown' },
    { id: 'orange', hex: '#ef6c00', asset: './assets/images/manipulative/coinsAndCounters/markerOrange.svg', colorLabelKey: 'text.coinsAndCountersColor_orange' },
    { id: 'green', hex: '#2e7d32', asset: './assets/images/manipulative/coinsAndCounters/markerGreen.svg', colorLabelKey: 'text.coinsAndCountersColor_green' },
    { id: 'purple', hex: '#9c27b0', asset: './assets/images/manipulative/coinsAndCounters/markerPurple.svg', colorLabelKey: 'text.coinsAndCountersColor_purple' },
    { id: 'black', hex: '#212121', asset: './assets/images/manipulative/coinsAndCounters/markerBlack.svg', colorLabelKey: 'text.coinsAndCountersColor_black' },
    { id: 'white', hex: '#fafafa', asset: './assets/images/manipulative/coinsAndCounters/markerWhite.svg', colorLabelKey: 'text.coinsAndCountersColor_white' },
    { id: 'grey', hex: '#64625F', asset: './assets/images/manipulative/coinsAndCounters/markerGrey.svg', colorLabelKey: 'text.coinsAndCountersColor_grey' },
];
// Quick lookup: variant id → asset path.
export var MARKER_ASSET_BY_ID = GAME_MARKER_PALETTE.reduce(function (acc, p) {
    acc[p.id] = p.asset;
    return acc;
}, {});
export var GAME_MARKER_DEFAULT_COLOR = GAME_MARKER_PALETTE[0].id;
